<template>
    <footer
        class="md-footer layout4"
        :class="[{ inner: inner }]"
        :style="{
            ...colorStyle,
            ...spaceStyle,
            ...bgImage
        }"
    >
        <div class="f-col footer-container">
            <div class="top-content">
                <div class="agent-logo">
                    <div class="logo-wrap">
                        <div class="site-logo" v-if="logos.length > 0">
                            <template v-for="(logo, index) in validLogos">
                                <a
                                    v-if="logo.logo.href"
                                    :key="index"
                                    :href="logo.logo.href"
                                    aria-label="site logo"
                                    rel="noopener noreferrer"
                                >
                                    <site-img
                                        class="logo-item"
                                        :src="logo.logo"
                                        alt="site logo"
                                        :style="{
                                            height: size / 100 + 'em'
                                        }"
                                        :ssrInitSize="30"
                                        dir="height"
                                    />
                                </a>
                                <site-img
                                    v-else
                                    class="logo-item"
                                    :key="'key-' + index"
                                    :src="logo.logo"
                                    alt="site logo"
                                    :style="{ height: size / 100 + 'em' }"
                                    :ssrInitSize="30"
                                    dir="height"
                                />
                            </template>
                        </div>
                    </div>
                    <div class="agent-wrap">
                        <div
                            v-if="companyInfo?.name"
                            class="co-name"
                            :style="footerBroNameStyle"
                            v-html="companyInfo.name"
                        ></div>
                        <div
                            v-if="
                                footerAgentInfo?.firstName ||
                                    footerAgentInfo?.lastName
                            "
                            class="agent-name"
                            :style="{
                                ...footerAgentInfoStyle
                            }"
                        >
                            {{ footerAgentInfo.firstName || '' }}
                            {{ footerAgentInfo.lastName || '' }}
                        </div>
                    </div>
                </div>

                <div class="top-center">
                    <ul class="menu-wrap main-menu" v-if="!isMobile">
                        <menu-item
                            v-for="(menu, index) in z_menus"
                            :key="index"
                            :selfKey="'menu-' + index"
                            :expandKey="expandKey"
                            :menu="menu"
                            :useMenuStyle="footerMenuStyle"
                            :useSubMenuStyle="footerSubMenuStyle"
                            @update-expand-key="updateExpandKey"
                        />
                    </ul>
                    <div class="detail-info">
                        <div class="agent-info">
                            <div
                                v-if="footerAgentInfo?.phone"
                                class="detail-phone agent-item"
                                :style="footerAgentInfoStyle"
                            >
                                <a
                                    :href="'tel:' + footerAgentInfo.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    <i class="iconfont icon-phone1"></i>
                                    <span class="text">
                                        {{
                                            $ft.formatPhone(
                                                footerAgentInfo.phone
                                            )
                                        }}
                                    </span>
                                </a>
                            </div>
                            <div
                                v-if="footerAgentInfo?.email"
                                class="detail-email agent-item"
                                :style="footerAgentInfoStyle"
                            >
                                <a
                                    :href="'mailto:' + footerAgentInfo.email"
                                    rel="noopener noreferrer"
                                >
                                    <i class="iconfont icon-v5-email"></i>
                                    <span class="text">
                                        {{ footerAgentInfo.email }}
                                    </span>
                                </a>
                            </div>
                            <div
                                v-if="getAddressInfo"
                                class="detail-addr agent-item"
                                :style="footerBroAddrStyle"
                            >
                                <i class="iconfont icon-address1"></i>
                                <span
                                    class="text"
                                    v-html="getAddressInfo"
                                ></span>
                            </div>
                        </div>
                        <div v-if="subOwnerName" class="detail">
                            <div class="site-title" v-text="subOwnerName"></div>
                            <p
                                v-if="!!subOwnerInfo.phone"
                                class="site-p underline"
                            >
                                <a
                                    :href="'tel:' + subOwnerInfo.phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    {{ $ft.formatPhone(subOwnerInfo.phone) }}
                                </a>
                            </p>
                            <p
                                v-if="!!subOwnerInfo.email"
                                class="site-p underline"
                            >
                                <a
                                    :href="'mailto:' + subOwnerInfo.email"
                                    rel="noopener noreferrer"
                                >
                                    {{ subOwnerInfo.email }}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="share-links-wrap">
                    <div v-if="socialNetworksInfo.length > 0" class="share-links">
                        <a
                            v-for="(social, index) in socialNetworksInfo"
                            :key="social.id + '-' + index"
                            class="share-item"
                            :href="social.url"
                            :aria-label="social.socialNetwork"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont" :class="social.icon"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="bottom-content">
                <closely-app-download
                    useModule="md-footer"
                    :downloadTheme="true"
                />
                <a
                    class="md-footer_notshare"
                    v-if="isDoNotShareShow"
                    href="/site/dsar"
                >
                    {{ $t('md-footer.doNotShare') }}
                    <i class="iconfont icon-arrow_08_right"></i>
                </a>
                <div class="detail other-cont">
                    <template v-if="agentHasDisclaimer">
                        <p
                            v-for="(
                                file, index
                            ) in footerAgentInfo.disclaimerList"
                            :key="index + 'mainfile'"
                            class="site-p detail-file"
                        >
                            <a :href="file.url" rel="noopener noreferrer">
                                {{ file.name.split('.')[0] }}
                            </a>
                        </p>
                    </template>
                    <template v-if="subOwnerHasDisclaimer">
                        <p
                            v-for="(file, index) in subOwnerInfo.disclaimerList"
                            :key="index + 'subfile'"
                            class="site-p detail-file"
                        >
                            <a :href="file.url" rel="noopener noreferrer">
                                {{ file.name.split('.')[0] }}
                            </a>
                        </p>
                    </template>
                    <div
                        v-if="footerAgentCustomContent"
                        class="site-p"
                        v-html="formatFontSize(footerAgentCustomContent)"
                    ></div>
                </div>
                <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                    <a
                        href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                        target="_blank"
                        :title="$t('md-footer.realEstateConsumer')"
                        rel="noopener noreferrer"
                    >{{ $t('md-footer.realEstateConsumer') }}</a>
                </div>
                <div
                    class="no-mls-disclaimer"
                    v-if="noMlsDisclaimers.length > 0"
                >
                    <div
                        class="claimer"
                        v-for="(noMls, index) in noMlsDisclaimers"
                        :key="index"
                        v-html="noMls.label"
                    ></div>
                </div>
                <MlsDisclaimer v-if="!wordPressSSR" @update="mlsUpdated" />

                <div v-if="!hideCopyRight" class="copyright">
                    <template v-if="gfFlag != '1'">
                        <p class="site-p tip-color">
                            <CopyrightLink
                                :gfFlag="gfFlag"
                                :isShowAccessibility="isShowAccessibility"
                            />
                        </p>
                        <p
                            class="site-p copyright-p"
                            v-if="showCopyright"
                            v-html="
                                $t('md-footer.madeInAndCopyright', {
                                    chimeLink,
                                    year
                                })
                            "
                        ></p>
                    </template>
                    <p v-else class="site-p tip-color">
                        {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                        <CopyrightLink
                            :gfFlag="gfFlag"
                            :isShowAccessibility="isShowAccessibility"
                        />
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index-layout';
import util from '@/common/util';
import { transformSrc } from '@/components/global/site-img.js';

export default {
    name: 'MdFooterLayout4',
    mixins: [common],
    computed: {
        bgImage() {
            let src = util.getImgSrcByPlatform(this.pictureOption, this.isMobile);
            let srcUrl = src?.imgUrl || src || '';
            srcUrl = transformSrc({ src: srcUrl, isMobile: this.isMobile });
            return srcUrl
                ? {
                    'background-image': `url("${srcUrl}")`
                }
                : {};
        }
    },
    data() {
        return {
            isDoNotShareShow: true
        };
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../index.scss';

.md-footer.layout4 {
    position: relative;
    background: center center no-repeat;
    background-size: cover;
    &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: var(--bg-color);
        opacity: 0.9;
    }
    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
    .footer-container {
        position: relative;
    }
    .top-content {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }
    .site-logo {
        font-size: 50px;
        .logo-item {
            display: block;
            height: 1em;
        }
        .logo-item + .logo-item {
            margin-top: 30px;
        }
    }
    .agent-wrap {
        .co-name {
            margin-top: 30px;
            font-weight: 700;
        }
        .agent-name {
            margin-top: 20px;
            font-family: var(--font-bold) !important;
            font-size: 18px !important;
        }
    }

    .menu-wrap {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        column-gap: 20px;
        row-gap: 40px;
        padding-bottom: 50px;
        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
        .menu-item {
            padding-left: 0;
            font-size: 16px;
            font-weight: 500;
            text-align: left;
            width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: var(--g-primary-color);
            .footer-menu,
            .footer-submenu {
                .menu-label,
                .iconfont,
                .sub-menu {
                    color: var(--g-primary-color) !important;  
                }
                &:hover {
                    .menu-label,
                    .iconfont {
                        color: var(--g-primary-color) !important;
                    } 
                }
            }
            .footer-menu .menu-label{
                position: relative;
                &:before {
                    content: ' ';
                    position: absolute;
                    left: 0%;
                    right: unset;
                    bottom: 0;
                    top: unset;
                    height: 1px;
                    width: 0%;
                    background-color: var(--g-primary-color);
                    -webkit-transition: width 0.3s ease;
                    transition: width 0.3s ease;
                }
                &:hover:before {
                    width: 100%;
                }
            }
            .footer-submenu {
                margin-top: 10px;
                .sub-menu {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 30px;
                    text-align: left;
                    &:hover {
                        color: var(--g-primary-color) !important;
                    }
                    > a {
                        position: relative;
                        &:before {
                            content: ' ';
                            position: absolute;
                            left: 0%;
                            right: unset;
                            bottom: 0;
                            top: unset;
                            height: 1px;
                            width: 0%;
                            background-color: var(--g-primary-color);
                            -webkit-transition: width 0.3s ease;
                            transition: width 0.3s ease;
                        }
                        &:hover:before {
                            width: 100%;
                        }
                    }
                }
            }
        }
        .icon-arrow-down {
            margin-left: 10px;
            font-size: 12px;
        }
        .down .icon-arrow-down {
            transform: rotate(180deg);
        }
    }

    .agent-info {
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        line-height: 1.7;
        .agent-item {
            padding-right: 21px;
            position: relative;
            a {
                height: 100%;
                display: flex;
                align-items: center;
            }
            .iconfont {
                display: none;
            }
            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 14px;
                background: var(--g-primary-color);
                opacity: 0.3;
                margin: 0 10px;
            }
            &:last-child::after {
                content: none;
            }
        }
    }

    .share-links-wrap {
        width: 150px;
    }
    .share-links {
        width: 150px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: flex-start;
        column-gap: 15px;
        row-gap: 20px;
        .share-item {
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 50%;
            position: relative;
            &::after {
                content: '';
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: var(--g-primary-color);
                opacity: 0.1;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
            }
            .iconfont {
                position: relative;
                z-index: 2;
                font-size: 15px;
                line-height: 40px;
                color: var(--g-primary-color);
            }
            &:hover {
                &:after {
                    opacity: 1;
                }
                .iconfont {
                    color: var(--bg-color);
                }
            }
        }
    }

    .other-cont {
        margin-top: 20px;
    }
    .detail {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .site-p {
            margin-top: 0;
            font-size: 14px;
            color: var(--g-primary-color);
        }
        .detail-addr {
            margin-top: 10px;
        }
    }

    .site-title {
        margin-top: 10px;
        font-size: 24px;
        text-align: center;
        font-weight: 700;
    }

    .detail-file {
        cursor: pointer;
        color: #797e8b;
    }
    .underline {
        text-decoration: underline;
    }

    .md-footer_notshare {
        margin-top: 40px;
        display: block;
        text-align: center;
        color: var(--g-primary-color);
        .icon-arrow_08_right {
            font-size: 12px;
            margin-left: 8px;
        }
    }
    .download-closely {
        display: flex;
        flex-direction: column-reverse;
        margin: 0 auto;
        align-items: center;
        gap: 10px;
        .code-title {
            font-size: 12px;
            margin-bottom: 0;
            color: var(--g-tip-color);
        }
        .download-link {
            text-align: center;
        }
        .code-wrapper {
            .qr-code {
                border-radius: 0;
            }
        }
    }
    .mls-declaimer-container .declaimer {
        padding-bottom: 20px;
    }
    .bottom-content {
        margin-top: 70px;
        @include no-mls-disclaimer;
        .no-mls-disclaimer {
            margin-top: 20px;
            text-align: center;
            color: var(--g-tip-color);
        }
        .mls-declaimer-container-v2 {
            padding-top: 60px;
            .declaimer {
                display: flex;
                flex-direction: column-reverse;
                gap: 15px;
                .content.site-p {
                    color: var(--g-text-color);
                    text-align: left;
                }
            }
            .declaimer + .declaimer {
                margin-top: 40px;
            }
        }
    }
    .copyright {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .cr {
            a {
                text-decoration: underline;
            }
        }

        .site-p,
        .copyright-p {
            color: var(--g-text-color);
        }
        a {
            white-space: nowrap;
        }
    }

    &.inner {
        .footer-container {
            padding: 0 var(--inner-padding, 20px);
        }
        .top-content {
           display: block;
        }
        .top-center {
            display: flex;
            flex-direction: column-reverse;
        }
        .menu-wrap {
            margin-left: 0;
            margin-right: 0;
            margin-top: 60px;
        }
        .agent-info {
            margin-top: 30px;
            justify-content: flex-start;
        }
        .share-links-wrap {
            width: 100%;
        }
        .share-links {
            width: 100%;
            margin-top: 50px;
            justify-content: flex-start;
        }
        .download-closely {
            margin-left: 0;
            align-items: flex-start;
            .code-title {
                margin-left: 18px;
            }
        }
        .md-footer_notshare {
            text-align: left;
        }
        .detail {
            align-items: flex-start;
        }
        .bottom-content {
            margin-top: 50px;
            .no-mls-disclaimer {
                text-align: left;
            }
            .mls-declaimer-container-v2 {
                padding-top: 50px;
                .declaimer .mls-logo .logo {
                    margin-left: 0;
                }
            }
        }
        .copyright {
            display: block;
            .copyright-p {
                margin-top: 20px;
            }
        }
    }

    @include media-800 {
        .top-content {
            display: block;
        }
        .agent-info {
            margin-top: 30px;
            justify-content: flex-start;
            line-height: 1.8;
            padding-bottom: 25px;
            border-bottom: 1px solid rgba(218, 218, 218, 0.5);
        }
        .share-links {
            margin-top: 25px;
            justify-content: flex-start;
            margin-left: 0;
            column-gap: 15px;
            row-gap: 20px;
        }
        .other-cont {
            margin-top: 15px;
        }
        .download-closely {
            margin-left: 0;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
        }
        .md-footer_notshare {
            text-align: left;
        }
        .detail {
            align-items: flex-start;
        }
        .bottom-content {
            margin-top: 25px;
            .no-mls-disclaimer {
                text-align: left;
            }
            .mls-declaimer-container-v2 {
                padding-top: 35px;
                .declaimer {
                    justify-content: flex-start;
                    gap: 18px;
                    .mls-logo {
                        margin-top: 0;
                        .logo {
                            margin-left: 0;
                        }
                    }
                    .content.site-p {
                        text-align: left;
                    }
                }
            }
        }
        .copyright {
            flex-direction: column;
            gap: 20px;
        }
    }
}
</style>
